import {
  SET_IS_LOADING,
  SET_PAGINATION_DATA_PROMOTION,
  SET_PROMOTION_DATA,
  SET_LAST_QUERY,
} from 'storeContext/actionsType/promotion'

import type {
  PromotionItemType,
  PromotionQueryType,
  PromotionPaginationType,
} from 'utils/apiList/promotion'

export type PromotionStateType = {
  isLoading: boolean
  promotionData: PromotionItemType[]
  paginationData: Partial<PromotionPaginationType>
  lastQuery: PromotionQueryType
}
export type PromotionActionType =
  | { type: typeof SET_IS_LOADING; payload: boolean }
  | { type: typeof SET_PROMOTION_DATA; payload: PromotionItemType[] }
  | { type: typeof SET_PAGINATION_DATA_PROMOTION; payload: PromotionPaginationType }
  | { type: typeof SET_LAST_QUERY; payload: PromotionQueryType }

export const initialStatePromotion: PromotionStateType = {
  isLoading: false,
  promotionData: [],
  paginationData: {},
  lastQuery: {},
}

export default function promotion(
  state: PromotionStateType = initialStatePromotion,
  { type, payload }: PromotionActionType,
): PromotionStateType {
  switch (type) {
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload,
      }
    case SET_PAGINATION_DATA_PROMOTION:
      return {
        ...state,
        paginationData: payload,
      }
    case SET_PROMOTION_DATA:
      return {
        ...state,
        promotionData: payload,
      }
    case SET_LAST_QUERY:
      return {
        ...state,
        lastQuery: payload,
      }
    default:
      return state
  }
}
